import axios from "axios";
import { Axios, baseUrl } from "../../Services/Axios";

export const fetchOrders = async (url = undefined, params = undefined) => {
  return await Axios.get(url || `/store/orders?${params || ""}`, {
    responseType: "json",
  });
};
export const fetchOrdersByCustomer = async (
  customerId = undefined,
  url = undefined,
  params = undefined
) => {
  return await Axios.get(
    url || `/store/customers/orders/${customerId}?status=all&${params || ""}`,
    {
      responseType: "json",
    }
  );
};
export const fetchOrderDetails = async (id) => {
  return await Axios.get(`/store/orders/${id}`, { responseType: "json" });
};
export const fetchLaundryItem = async ({
  serviceId,
  categoryId,
  limit,
  offset,
}, signal) => {
  const token = localStorage.getItem("token");
  const ss = localStorage.getItem("store");
  let zoneId;
  if (ss) {
    const store = JSON.parse(ss);
    zoneId = store?.zone_id;
  }
  return await axios
    .get(
      `${baseUrl}/api/laundry-item/list/service/${serviceId}/category/${categoryId}?limit=${limit}&offset=${offset}`,
      {
        signal: signal,
        headers: {
          Laundryzoneid: zoneId,
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((x) => x.data);
};
export const fetchTimeSlot = async (
  date,
  type,
  orderType,
  p_id,
  p_date,
  laundryDeliveryTypeId
) => {
  const ss = localStorage.getItem("store");
  let zone;
  let id;

  if (ss) {
    const store = JSON.parse(ss);
    zone = store?.zone_id;
    id = store?.store_id;
  }

  let url = `/store/time-slot/${zone}/${date}/${type}/${orderType}?store_id=${id}`;

  if (p_id) url += `&p_id=${p_id}`;
  if (p_date) url += `&p_date=${p_date}`;
  if (laundryDeliveryTypeId) {
    url += `&laundry_delivery_type_id=${laundryDeliveryTypeId}`;
  }

  return await Axios.get(url);
};

export const updateOrder = async (payload) => {
  return await Axios.post("/store/update-orders", payload, {
    responseType: "json",
  });
};
export const addOrder = async (payload, idempotencyKey = crypto.randomUUID()) => {
  const token = localStorage.getItem("token");
  const ss = localStorage.getItem("store");
  let zoneId;
  if (ss) {
    const store = JSON.parse(ss);
    zoneId = store?.zone_id;
  }
  return await axios
    .post(`${baseUrl}/api/store/create-orders`, payload, {
      headers: {
        "Idempotency-Key": idempotencyKey,
        Laundryzoneid: zoneId,
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      responseType: "json",
    })
    .then((x) => x.data);
};
export const fetchServices = async (limit, offset, deliveryType) => {
  const order_process = localStorage.getItem("processing");
  return await Axios.get(
    `${
      order_process === "hub" ? "/services/list" : "/store/services"
    }?limit=${limit}&offset=${offset}&delivery_type_id=${
      deliveryType == 1 || deliveryType == 2 || !deliveryType ? 0 : deliveryType
    }`
  );
};

export const fetchCoupon = async (payload) => {
  return await Axios.post("/store/apply-coupon", payload);
};
